export default "__VITE_ASSET__d4c90ff3__"